require('./userNotificationsSectionContent.scss');

//@ vendors
const PropTypes = require('prop-types');
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
//@ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
//@ components
const UserNotificationsSectionHeader = require('components/userNotifications/userNotificationsSection/userNotificationsSectionHeader/userNotificationsSectionHeader');
const UserNotificationsSectionList = require('components/userNotifications/userNotificationsSection/userNotificationsSectionList/userNotificationsSectionList');

class UserNotificationsSectionContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            downloadModalOpen: false
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.buildNextPageButton = this.buildNextPageButton.bind(this);
        this.buildEmptyState = this.buildEmptyState.bind(this);
        this.buildConectionError = this.buildConectionError.bind(this);
    }

    buildConectionError() {
        const { onRetry } = this.props;
        const lostConnectionFirstLine = formatText('userNotificationsSection-lostConnectionFirstLine');
        const retryButton = (
            <OKButton onClick={onRetry}>
                <FormattedText value="userNotificationsSection-retry" />
            </OKButton>
        );

        return <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-banking"/>;
    }

    buildEmptyState() {
        const { immFilters } = this.props;
        let messageKey = 'userNotificationsSection-noResults';

        if (
            immFilters.getIn(['date', 'isActive']) ||
            immFilters.getIn(['situation', 'isActive']) ||
            immFilters.getIn(['state', 'isActive'])
        ) {
            messageKey = 'userNotificationsSection-noResultsWithFilters';
        }

        const primaryText = formatText(messageKey);
        return <EmptyState primaryText={primaryText} iconType="search-banking"/>;
    }

    buildNextPageButton() {
        return (
            <div className="user-notifications-section-content__button-container">
                <OKButton onClick={this.handleNextPage} modifier="link-complementary">
                    <FormattedText value="userNotificationsSection-seeMoreNotifications" />
                </OKButton>
            </div>
        );
    }

    handleNextPage() {
        const { requestNextUserNotificationsPage, immUserNotifications } = this.props;
        const nextPageUrl = immUserNotifications.get('nextPage');
        requestNextUserNotificationsPage(nextPageUrl);
    }

    render() {
        const {
            flagBasedFeatures,
            getChoreDetail,
            immCards,
            immUserNotifications,
            moneySavingsRequestDetails,
            openYoungCardChores,
            onFilterClick,
            requestUserNotifications,
            getMoneyRequestDetails
        } = this.props;
        let nextPageLoadingSection;
        let nextPageButton;
        let tableContent;

        if (immUserNotifications) {
            const isLoading = immUserNotifications.get('isFetching');
            const notificactionsEmpty = immUserNotifications.get('notifications').size === 0;
            const hasError = !!immUserNotifications.get('error');

            if (isLoading) {
                tableContent = <LoadingSection />;
            } else if (hasError) {
                tableContent = this.buildConectionError();
            } else if (notificactionsEmpty) {
                tableContent = this.buildEmptyState();
            } else {
                tableContent = (
                    <UserNotificationsSectionList
                        flagBasedFeatures={flagBasedFeatures}
                        getChoreDetail={getChoreDetail}
                        immCards={immCards}
                        immUserNotifications={immUserNotifications}
                        openYoungCardChores={openYoungCardChores}
                        requestUserNotifications={requestUserNotifications}
                        getMoneyRequestDetails={getMoneyRequestDetails}
                        moneySavingsRequestDetails={moneySavingsRequestDetails}
                    />
                );

                if (immUserNotifications.get('isFetchingNextPage')) {
                    nextPageLoadingSection = <LoadingSection />;
                } else if (immUserNotifications.get('nextPage')) {
                    nextPageButton = this.buildNextPageButton();
                }
            }
        } else {
            tableContent = <LoadingSection />;
        }

        return (
            <div className="user-notifications-section-content">
                <UserNotificationsSectionHeader onFilterClick={onFilterClick} />
                {tableContent}
                {nextPageLoadingSection}
                <div className="user-notifications-section-content__actions row no-gutter">
                    <div className="col-xs-12">
                        {nextPageButton}
                    </div>
                </div>
            </div>
        );
    }
}

UserNotificationsSectionContent.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getChoreDetail: PropTypes.func.isRequired,
    getMoneyRequestDetails: PropTypes.func.isRequired,
    immCards: PropTypes.object.isRequired,
    immUserNotifications: PropTypes.object.isRequired,
    immFilters: PropTypes.object.isRequired,
    moneySavingsRequestDetails: PropTypes.func.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    onRetry: PropTypes.func.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    requestNextUserNotificationsPage: PropTypes.func,
    requestUserNotifications: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired
};

module.exports = UserNotificationsSectionContent;
